import UsedTechnology from './UsedTechnoolgy.jsx';

export default UsedTechnology;
